import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import Scan from './pages/Scan';
import ScanResult from './pages/ScanResult';
import Situations from './pages/Situations';
import International from './pages/International';
import InternationalScan from './pages/InternationalScan';
import KnowledgeBase from './pages/KnowledgeBase';
import Tools from './pages/Tools';
import InheritanceTaxAnalysis from './pages/InheritanceTaxAnalysis';
import TestamentCheck from './pages/TestamentCheck';
import Faq from './pages/Faq';
import About from './pages/About';
import Contact from './pages/Contact';
import BlendedFamily from './pages/BlendedFamily';
import Entrepreneur from './pages/Entrepreneur';
import InternationalLanding from './pages/InternationalLanding';
import LegalPage from './pages/LegalPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/nl" replace />} />
        
        {/* Multilingual Route Wrapper */}
        <Route path="/:lang" element={<Layout />}>
          <Route index element={<Home />} />
          
          {/* Main Nav Slugs */}
          <Route path="hoe-het-werkt" element={<HowItWorks />} />
          <Route path="how-it-works" element={<HowItWorks />} />
          
          <Route path="scan" element={<Scan />} />
          <Route path="testament-scan/resultaat" element={<ScanResult />} />
          
          <Route path="situaties" element={<Situations />} />
          <Route path="situations" element={<Situations />} />
          
          <Route path="situaties/samengesteld-gezin" element={<BlendedFamily />} />
          <Route path="situations/blended-family" element={<BlendedFamily />} />
          
          <Route path="situaties/ondernemer" element={<Entrepreneur />} />
          <Route path="situations/entrepreneur" element={<Entrepreneur />} />
          
          <Route path="situaties/internationaal" element={<InternationalLanding />} />
          <Route path="situations/international" element={<InternationalLanding />} />
          
          <Route path="internationaal" element={<International />} />
          <Route path="international" element={<International />} />
          
          <Route path="internationaal/scan" element={<InternationalScan />} />
          <Route path="international/scan" element={<InternationalScan />} />
          
          <Route path="kennisbank" element={<KnowledgeBase />} />
          <Route path="insights" element={<KnowledgeBase />} />
          
          <Route path="tools" element={<Tools />} />
          <Route path="tools/erfbelasting-analyse" element={<InheritanceTaxAnalysis />} />
          <Route path="tools/inheritance-tax-analysis" element={<InheritanceTaxAnalysis />} />
          <Route path="tools/testament-check" element={<TestamentCheck />} />
          
          <Route path="faq" element={<Faq />} />
          
          <Route path="over-ons" element={<About />} />
          <Route path="about-us" element={<About />} />
          
          <Route path="contact" element={<Contact />} />

          {/* Legal Slugs */}
          <Route path="privacy" element={<LegalPage type="privacy" />} />
          <Route path="cookies" element={<LegalPage type="cookies" />} />
          <Route path="algemene-voorwaarden" element={<LegalPage type="terms" />} />
          <Route path="terms" element={<LegalPage type="terms" />} />
          <Route path="disclaimer" element={<LegalPage type="disclaimer" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;